import axios from 'axios';
export default {
    name: 'AddActivity',
    components: {

    },
    computed: {

    },
    data() {
        return {
            initialized: false,
            clients: [],
            record: {
                id: 0,
                title: '',
                color: '#000000',
                startDate: new Date().toISOString().split('T')[0],
                startTimeNew: String(new Date().getHours()).padStart(2, '0') + ':' +
                    String(new Date().getMinutes()).padStart(2, '0'),
                startTime: {
                    HH: '00',
                    mm: '00',
                },
                startLocation: '',
                endDate: new Date().toISOString().split('T')[0],
                endTimeNew: String(new Date().getHours()).padStart(2, '0') + ':' +
                    String(new Date().getMinutes()).padStart(2, '0'),
                endTime: {
                    HH: '00',
                    mm: '00',
                },
                state: 0,
                maximumUserCount: 0,
                isRecurring: false,
                overrideReason: '',
                locationId: 0,
                educationQualifications: []
            },
            selectedUsers: [],
            educationqualifications: [],
            overrideUsers: [],
            apperrors: [],
            templateType: 'standard',
            readonly: 'readonly'
        };
    },
    watch: {
        templateType() {
            this.setEndDate();
        },
        page() {
            this.fetch();
        },
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            this.initialized = false;
            let clientUrl = APIURL + '/applicationuser/list/clientall/' + '?active=true';
            let clientResponse = axios.get(clientUrl)
                .then(resp => {
                    this.clients = resp.data;
                });
            let educationQualificationsUrl = APIURL + '/educationqualification/all/';
            let educationQualificationsResponse = axios.get(educationQualificationsUrl)
                .then(resp => {
                    this.educationqualifications = resp.data;
                });
            Promise.all([clientResponse, educationQualificationsResponse])
                .then(() => {
                    this.initialized = true;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });

        },
        save() {
            this.setStartEndTime();
            this.apperrors = [];
            if (!this.validate()) {
                return;
            }
            let url = APIURL + '/activity/saveactivity/';
            axios.post(url, this.record)
                .then(resp => {
                    this.record = resp.data;
                    this.saveActivity();

                });
        },
        saveActivity() {
            let availableClientUrl = APIURL + '/activity/' + this.record.id + '/registeredforclients/';
            let saveClient = axios.put(availableClientUrl, this.selectedUsers)
                .then(resp => { });
            let reasonurl = APIURL + '/activity/' + this.record.id + '/overridereason';
            let reasondata = this.overrideUsers.map(x => ({
                applicationUserId: x.id,
                activityPeriodId: null,
                activityId: this.record.id,
                reason: this.record.overrideReason,
                overrideType: 0,
                warning: x.name + ' staat op hetzelfde moment bij ' + x.data
            }));
            let saveReason = axios.put(reasonurl, reasondata);

            Promise.all([saveClient, saveReason])
                .then(() => {
                    window.location.reload(true);
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });

        },
        validate() {
            let valid = true;
            let sdate = new Date(`${this.record.startDate}T${this.record.startTimeNew}:00`);
            let edate = new Date(`${this.record.endDate}T${this.record.endTimeNew}:00`);
            console.log(edate);
            console.log(sdate);
            if (sdate >= edate) {
                this.apperrors.push("enddate should greater than enddate!");
                valid = false;
            }
            if (!this.record.title) {
                this.apperrors.push("add title for activity !");
                valid = false;
            }
            if (this.selectedUsers == null ||
                this.selectedUsers.length == 0) {
                this.apperrors.push("missing young people !");
                valid = false;
            }
            if (this.record.educationQualifications == null ||
                this.record.educationQualifications.length == 0) {
                this.apperrors.push("missing qualifications !");
                valid = false;
            }
            if (this.record.locationId <= 0) {
                this.apperrors.push("missing location !");
                valid = false;
            }
            return valid;
        },
        dismiss() {
            this.$vuedals.dismiss();
        },
        setSelectedUsers(user, checked) {
            if (checked) {
                this.setStartEndTime();
                axios.post(APIURL + '/activity/client-activity-exists/' + user.id, this.record)
                    .then(resp => {
                        if (resp.data) {
                            this.overrideUsers.push({ 'name': user.name, 'id': user.id, 'data': resp.data });
                        }
                        this.selectedUsers.push(user);
                    });
            }
            else {
                this.selectedUsers = this.selectedUsers.filter(s => s.id != user.id);
                this.overrideUsers = this.overrideUsers.filter(s => s.id != user.id);
            }
        },
        setQualifications(item, checked) {
            if (checked) {
                this.record.educationQualifications.push(item.id);
            }
            else {
                this.record.educationQualifications = this.record.educationQualifications.filter(s => s != item.id);
            }
        },
        setStartEndTime() {
            this.record.startTime = {
                HH: this.record.startTimeNew.split(':')[0],
                mm: this.record.startTimeNew.split(':')[1],
            };
            this.record.endTime = {
                HH: this.record.endTimeNew.split(':')[0],
                mm: this.record.endTimeNew.split(':')[1],
            };
        },
        setEndDate() {
            if (this.templateType == 'standard') {
                this.record.endDate = this.record.startDate;
            }
        }
    }
};